/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */
import type { FC } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ERequestStatus, IApiError } from '@/main/types/globalTypes';
import { Button } from '@components/common';
import { ImgStatusError, ImgStatusSuccess } from '@components/common/Block/Img';
import { makeSelectTranslationCommon } from '@modules/internationalization/intSelectors';
import Modal from '@modules/modal/components/Modal';
import { ModalCenterStyled } from '@modules/modal/components/styled/ModalCenterStyled';
import { modalSetStatusAction } from '@modules/modal/modalActions';
import { EModalStatus } from '@modules/modal/types/modalTypes';

export interface IProps {
    mode: ERequestStatus;
    title: string;
    mainText?: string;
    extraText?: string;
    requestError?: IApiError;
    onCloseModal?: () => void;
};

export const ConstructorRequestStatusModal: FC<IProps> = (
    { mode, title, mainText, extraText, onCloseModal },
    ) => {
    const dispatch = useDispatch();

    const tCommon = useSelector(makeSelectTranslationCommon());

    const isSuccessMode = mode === ERequestStatus.success;

    const handleClick = () => {
        if (onCloseModal) {
            onCloseModal();
        } else {
            dispatch(modalSetStatusAction({
                status: EModalStatus.start,
            }));
        }
    };

    return (
        <ModalCenterStyled>
            {isSuccessMode ? <ImgStatusSuccess /> : <ImgStatusError />}
            <Modal.Title>{title}</Modal.Title>
            {isSuccessMode && (
                <>
                    {!!mainText && <Modal.Text>{mainText}</Modal.Text>}
                    {!!extraText && <Modal.Text className='success-modal-extraText'>{extraText}</Modal.Text>}
                </>
            )}
            {!isSuccessMode && <Modal.Text>{tCommon.error.defaultMessage}</Modal.Text>}
            <Modal.Control>
                <Button onClick={handleClick}>
                    {isSuccessMode ? tCommon.modal.good : tCommon.modal.accessibly}
                </Button>
            </Modal.Control>
        </ModalCenterStyled>
    );
};
